export const GlobalSnackbarService = (() => {
  const listeners = []

  return {
    addListener: listener =>
      typeof listener === 'function' ? listeners.push(listener) : -1,
    emit: (message, variant) => listeners.forEach(l => l(message, variant))
  }
})()
